import { EditHTML } from './edit-html.js';
import { Snippet } from './html-snippet.js';

export function HTML (pEditor)
{
  this.editor = new EditHTML(pEditor, this);
  this.snippet = new Snippet(pEditor, this);

}